import {Button, Card, CardBody, CardHeader, Typography,} from "@material-tailwind/react";
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {ServiceRequestForm} from "./service_request_form";
import {getPersonServices} from "../../services/service/service";
import {PersonServiceGrid} from "./person_service_grid";
import {PersonServiceCheckForm} from "./person_service_check";
import {PersonServiceDocumentationForm} from "./person_service_documentation_form";
import {InvoiceForm} from "./invoice_form";
import {ServiceContext} from "../../context/service";
import {ChargeWalletForm} from "./charge_wallet_form";
import {ServiceActivities} from "./service_activity";
import {CardFooterPaginator} from "../system/cardFooterPaginator";
import {AgentPanel} from "../system/agents_panel";
import {ConfirmationForm} from "./confirmation_form";
import {BsInfoCircle} from "react-icons/bs";
import {GuideForm} from "./guide_form";
import {PaginateContext} from "../../context/paginate";
import {PersonServiceHeaderAlert} from "../alert/service/person_service_header_alert";
import {PersonServiceSideCostForm} from "./person_service_side_cost_form";
import {getBackOfficePersonServices} from "../../services/back_office/service";
import {getServicePaymentAndSteps} from "../../services/service/service_step";
import {LoadingOverlay} from "../system/loading_overlay";

const profileServiceModal = process.env.NODE_ENV !== "production";

export function PersonServiceManagement({person_id}) {


  const handleOpen = () => setModalOpen(!modalOpen);

  const [step, setStep] = useState(null);

  const [personServices, setPersonServices] = useState([]);
  const serviceDetailCacheRef = useRef({});
  const prefetchingServiceIds = useRef(new Set());
  const [modalOpen, setModalOpen] = useState(false);
  const [gridRowCount, setGridRowCount] = useState(10);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridSelectedRow, setGridSelectedRow] = useState(null);
  const [documentGridSelectedRow, setDocumentGridGridSelectedRow] = useState(null);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);

  const [serviceSteps, setServiceSteps] = useState(null)
  const [serviceStep, setServiceStep] = useState(null)
  const [sideCosts, setSideCosts] = useState([])
  const [sideCost, setSideCost] = useState([])
  const [serviceStepsUpdated, setServiceStepsUpdated] = useState(null)
  const [totalSideCosts, setTotalSideCosts] = useState(0)
  const [totalDays, setTotalDays] = useState(0)

  const [agentId, setAgentId] = useState(null);
  const [branchId, setBranchId] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [loading, setLoading] = useState(false);

  const [branchInfo, setBranchInfo] = useState(null);

  const [show, setShow] = useState(4);

  const [personId, setPersonId] = useState(person_id);

  useEffect(() => {
    setPersonId(person_id)
    setGridSelectedRow(null)
    setDocumentGridGridSelectedRow(null)
    setStep(null)
    setModalOpen(false)
  }, [person_id]);

  useEffect(() => {
    if (localStorage.getItem("agentId")) {
      const new_agent_id = localStorage.getItem("agentId")
      setAgentId(new_agent_id)
      localStorage.removeItem("agentId")
    }

    if (localStorage.getItem("branchId")) {
      const new_branch_id = localStorage.getItem("branchId")
      setBranchId(new_branch_id)
      localStorage.removeItem("branchId")
    }

    setDataLoaded(true);
  }, [])

  const [chargeAmount, setChargeAmount] = useState(null);
  const [chargeDiscountCode, setChargeDiscountCode] = useState("");

  const openCheckModal = useCallback((selectedService) => {
    setGridSelectedRow(selectedService);
    setStep("check");
    setModalOpen(true);
  }, []);

  const openReportModal = useCallback((selectedService) => {
    setGridSelectedRow(selectedService);
    setStep("report");
    setModalOpen(true);
  }, []);

  const prefetchServiceDetails = (services) => {
    if (profileServiceModal && services?.length > 0) {
      console.debug("[service-modal][person] prefetch batch", {
        count: services.length,
      });
    }

    services?.forEach((service) => {
      if (!service?.id || serviceDetailCacheRef.current[service.id] || prefetchingServiceIds.current.has(service.id)) {
        return;
      }

      prefetchingServiceIds.current.add(service.id);
      const startedAt = profileServiceModal ? performance.now() : 0;
      getServicePaymentAndSteps(service.id).then((result) => {
        if (profileServiceModal) {
          console.debug("[service-modal][person] prefetch detail", {
            serviceId: service.id,
            status: result.status,
            durationMs: Math.round(performance.now() - startedAt),
          });
        }
        if (result.status === 200) {
          serviceDetailCacheRef.current[service.id] = result.data;
        }
      }).finally(() => {
        prefetchingServiceIds.current.delete(service.id);
      });
    });
  };

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(paginate) {
    try {
      setLoading(true);
      let result;
      if (!personId) {
        result = await getPersonServices(paginate);
      } else {
        result = await getBackOfficePersonServices(paginate, personId)
      }
      if (result.status === 200) {
        const {personServiceList, total_count} = result.data;
        setPersonServices(personServiceList || []);
        setGridTotalRowCount(total_count);
        prefetchServiceDetails(personServiceList || []);
        if (gridSelectedRow?.id) {
          const selectedService = personServiceList?.find((item) => item.id === gridSelectedRow.id)
          if (selectedService) {
            setGridSelectedRow(selectedService)
            setStep("check")
          }
        }
      }
    } finally {
      setLoading(false);
    }
  }


  useEffect(() => {
    let service = localStorage.getItem("service")
    let discountCode = localStorage.getItem("discountCode")
    if (service) {
      service = JSON.parse(service)
      setGridSelectedRow(service)
      setModalOpen(true)
      setChargeDiscountCode(discountCode)
      setStep("invoice")
      localStorage.removeItem("service")
      localStorage.removeItem("discountCode")
    }

    const paginate = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    }).toString()

    getData(paginate)
  }, [personId, lastDataRefresh, gridCurrentPage, gridRowCount, sortBy, sortType]);

  const serviceContextValue = useMemo(() => ({
    modalOpen,
    setModalOpen,
    gridRowCount,
    setGridRowCount,
    gridCurrentPage,
    setGridCurrentPage,
    service: gridSelectedRow,
    setService: setGridSelectedRow,
    document: documentGridSelectedRow,
    setDocument: setDocumentGridGridSelectedRow,
    lastDataRefresh,
    setLastDataRefresh,
    step,
    setStep,
    from: "person",
    branchInfo,
    setBranchInfo,
    serviceStep: serviceSteps,
    setServiceStep: setServiceSteps,
    serviceSteps: serviceSteps,
    setServiceSteps: setServiceSteps,
    serviceStepsUpdated: serviceStepsUpdated,
    setServiceStepsUpdated: setServiceStepsUpdated,
    totalDays: totalDays,
    setTotalDays: setTotalDays,
    totalSideCost: totalSideCosts,
    setTotalSideCosts: setTotalSideCosts,
    services: personServices,
    setServices: setPersonServices,
    sideCost: sideCost,
    setSideCost: setSideCost,
    sideCosts: sideCosts,
    setSideCosts: setSideCosts,
    show: show,
    setShow: setShow,
    chargeAmount: chargeAmount,
    setChargeAmount: setChargeAmount,
    chargeDiscountCode: chargeDiscountCode,
    setChargeDiscountCode: setChargeDiscountCode,
    serviceDetailCacheRef,
  }), [
    modalOpen, gridRowCount, gridCurrentPage, gridSelectedRow, documentGridSelectedRow,
    lastDataRefresh, step, branchInfo, serviceSteps, serviceStepsUpdated, totalDays,
    totalSideCosts, personServices, sideCost, sideCosts, show, chargeAmount, chargeDiscountCode,
  ]);

  const paginateContextValue = useMemo(() => ({
    setSortBy: setSortBy,
    sortType: sortType,
    setSortType: setSortType,
    active: gridCurrentPage,
    setActive: setGridCurrentPage,
    totalRows: gridTotalRowCount,
    rowsCount: gridRowCount,
    setRowsCount: setGridRowCount,
    from: from,
    to: to,
  }), [sortType, gridCurrentPage, gridTotalRowCount, gridRowCount, from, to]);

  if (dataLoaded) {
    return (
      <ServiceContext.Provider value={serviceContextValue}>
        <PaginateContext.Provider value={paginateContextValue}>
          <div className="flex w-full flex-col gap-4 p-4">
            {step === "check" &&
              <PersonServiceCheckForm/>
            }
            {step === "documentation" &&
              <PersonServiceDocumentationForm/>
            }
            {step === "new" &&
              <ServiceRequestForm agentId={agentId}/>
            }
            {step === "invoice" &&
              <InvoiceForm person_id={personId}/>
            }
            {step === "charge_wallet" &&
              <ChargeWalletForm/>
            }
            {step === "report" &&
              <ServiceActivities/>
            }
            {step === "confirmation" &&
              <ConfirmationForm person_id={personId}/>
            }
            {step === "guide" &&
              <GuideForm/>
            }
            {step === "side_cost" &&
              <PersonServiceSideCostForm/>
            }
            <Card className="w-full pt-8">
              <CardHeader floated={true} shadow={false} className="flex flex-row rounded-none justify-between">
                <div className="mb-4 flex items-center justify-between">
                  <Typography variant="h5" color="blue-gray">خدمات من</Typography>
                </div>
                <Button className="flex items-center gap-x-2 py-0 h-12" size="small" variant="outlined" onClick={() => {
                  setStep("guide")
                  setModalOpen(true)
                }}>
                  <BsInfoCircle className="h-5 w-5"/>
                  <Typography className="font-light">
                    راهنما
                  </Typography>
                </Button>
              </CardHeader>

              <CardBody className="flex w-full flex-col gap-3 px-4 pb-4">
                <AgentPanel
                  person_id={personId}
                  agent_id={agentId}
                  branch_id={branchId}
                  setAgentId={setAgentId}
                  type="service"
                />
                <PersonServiceHeaderAlert/>
              </CardBody>
            </Card>

            <Card className="w-full">
              <CardBody className="w-full overflow-x-auto p-0">
                {loading && <LoadingOverlay />}
                <div className="relative">
                  <PersonServiceGrid
                    services={personServices}
                    onOpenCheck={openCheckModal}
                    onOpenReport={openReportModal}
                  />
                </div>
              </CardBody>
              <CardFooterPaginator/>
            </Card>
          </div>
        </PaginateContext.Provider>
      </ServiceContext.Provider>
    );
  }
}
